import React from 'react';

const PROTOCOL_ICONS = {
  // Uniswap: pink unicorn silhouette
  "Uniswap V3": (
    <>
      <circle cx="8" cy="8" r="7" fill="#FF007A" />
      <path d="M5.5 11c0-2 0.8-3 1.5-3.5 0.5-0.3 0.5-1.2 0.5-2V4c0 0 1 0.8 1 2.5 0.5-0.5 0.5-1.5 0.5-1.5s1.5 1.5 1 4c-0.2 1-1 2-2.5 2.5" fill="#fff" opacity="0.9" />
      <circle cx="7" cy="7.5" r="0.5" fill="#FF007A" />
    </>
  ),
  "Uniswap V4": (
    <>
      <circle cx="8" cy="8" r="7" fill="#FF007A" />
      <path d="M5.5 11c0-2 0.8-3 1.5-3.5 0.5-0.3 0.5-1.2 0.5-2V4c0 0 1 0.8 1 2.5 0.5-0.5 0.5-1.5 0.5-1.5s1.5 1.5 1 4c-0.2 1-1 2-2.5 2.5" fill="#fff" opacity="0.9" />
      <circle cx="7" cy="7.5" r="0.5" fill="#FF007A" />
    </>
  ),
  // Curve: three curved swoosh lines
  Curve: (
    <>
      <circle cx="8" cy="8" r="7" fill="#E8471A" opacity="0.15" />
      <path d="M3.5 10C5 6 7 4 9 4s3 1.5 3.5 3" stroke="#E8471A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      <path d="M3.5 11.5C5 7.5 7 5.5 9 5.5s3 1.5 3.5 3" stroke="#E8471A" strokeWidth="1" fill="none" strokeLinecap="round" opacity="0.5" />
    </>
  ),
  // Balancer: three horizontal bars decreasing width
  Balancer: (
    <>
      <circle cx="8" cy="8" r="7" fill="#1E1E1E" />
      <rect x="4" y="4.5" width="8" height="1.6" rx="0.8" fill="#fff" />
      <rect x="5" y="7.2" width="6" height="1.6" rx="0.8" fill="#fff" />
      <rect x="6" y="9.9" width="4" height="1.6" rx="0.8" fill="#fff" />
    </>
  ),
  // PancakeSwap: bunny face
  PancakeSwap: (
    <>
      <circle cx="8" cy="9" r="5.5" fill="#1FC7D4" opacity="0.15" />
      <ellipse cx="8" cy="10" rx="3.5" ry="3" fill="#1FC7D4" />
      <ellipse cx="5.5" cy="5" rx="1.3" ry="3" fill="#1FC7D4" />
      <ellipse cx="10.5" cy="5" rx="1.3" ry="3" fill="#1FC7D4" />
      <ellipse cx="5.5" cy="5.5" rx="0.7" ry="1.8" fill="#fff" opacity="0.4" />
      <ellipse cx="10.5" cy="5.5" rx="0.7" ry="1.8" fill="#fff" opacity="0.4" />
      <circle cx="7" cy="9.5" r="0.6" fill="#fff" />
      <circle cx="9" cy="9.5" r="0.6" fill="#fff" />
    </>
  ),
  // Raydium: gradient prism/diamond
  Raydium: (
    <>
      <defs>
        <linearGradient id="ray-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#2B6DEF" />
          <stop offset="100%" stopColor="#68DEFE" />
        </linearGradient>
      </defs>
      <polygon points="8,2 14,8 8,14 2,8" fill="url(#ray-g)" />
      <polygon points="8,4.5 11.5,8 8,11.5 4.5,8" fill="#fff" opacity="0.25" />
    </>
  ),
  // Orca: whale shape in yellow circle
  Orca: (
    <>
      <circle cx="8" cy="8" r="7" fill="#FFD15C" />
      <path d="M4 8.5c0-2.5 2-4 4-4s4 1.5 4 4c0 1.5-0.8 2.5-2 3l0.5 1.5h-1l-0.5-1c-0.3 0-0.7 0.1-1 0.1s-0.7 0-1-0.1l-0.5 1h-1l0.5-1.5c-1.2-0.5-2-1.5-2-3z" fill="#fff" />
      <circle cx="6" cy="7.5" r="0.8" fill="#000" />
    </>
  ),
  // Kamino: green K diamond
  Kamino: (
    <>
      <circle cx="8" cy="8" r="7" fill="#32D583" opacity="0.15" />
      <path d="M8 2L14 8l-6 6-6-6 6-6z" fill="none" stroke="#32D583" strokeWidth="1.5" />
      <path d="M6 5v6m0-3l3-3m-3 3l3 3" stroke="#32D583" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  // Aerodrome: blue wing/aero shape
  Aerodrome: (
    <>
      <circle cx="8" cy="8" r="7" fill="#0052FF" />
      <path d="M3 10.5L8 4l5 6.5H3z" fill="#fff" opacity="0.9" />
      <path d="M5.5 10.5L8 6.5l2.5 4H5.5z" fill="#0052FF" />
    </>
  ),
  // Velodrome: red V speedometer
  Velodrome: (
    <>
      <circle cx="8" cy="8" r="7" fill="#FF0000" opacity="0.12" />
      <path d="M3 4.5l5 8.5 5-8.5" stroke="#FF0000" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="8" cy="4" r="1" fill="#FF0000" />
    </>
  ),
  // SushiSwap: sushi roll
  SushiSwap: (
    <>
      <ellipse cx="8" cy="9.5" rx="5" ry="3.5" fill="#0E0F23" />
      <ellipse cx="8" cy="8" rx="5" ry="3.5" fill="#D93B8E" />
      <ellipse cx="8" cy="7.5" rx="3" ry="2" fill="#fff" opacity="0.3" />
      <ellipse cx="8" cy="7.8" rx="1.8" ry="1.2" fill="#E84142" opacity="0.7" />
    </>
  ),
  // Trader Joe: red hat
  "Trader Joe": (
    <>
      <circle cx="8" cy="8" r="7" fill="#E84142" opacity="0.12" />
      <path d="M3 9h10v1.5c0 1-2 2-5 2s-5-1-5-2V9z" fill="#E84142" />
      <path d="M4.5 9V6c0-1.5 1.5-3 3.5-3s3.5 1.5 3.5 3v3" fill="#E84142" opacity="0.8" />
      <rect x="2.5" y="8.5" width="11" height="1.5" rx="0.75" fill="#E84142" />
    </>
  ),
  // Camelot: golden sword/excalibur
  Camelot: (
    <>
      <circle cx="8" cy="8" r="7" fill="#FFAF1D" opacity="0.12" />
      <rect x="7.3" y="2" width="1.4" height="8" rx="0.3" fill="#FFAF1D" />
      <rect x="5" y="10" width="6" height="1.4" rx="0.7" fill="#FFAF1D" />
      <rect x="7" y="11.5" width="2" height="2.5" rx="0.5" fill="#FFAF1D" opacity="0.7" />
    </>
  ),
};

export default function ProtocolIcon({ protocol, size = 16 }) {
  const icon = PROTOCOL_ICONS[protocol];

  if (!icon) {
    return (
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: '50%',
        background: '#888',
        color: '#fff',
        fontSize: size * 0.55,
        fontFamily: "'IBM Plex Mono', monospace",
        fontWeight: 600,
        lineHeight: 1,
        flexShrink: 0,
      }}>
        {(protocol || '?')[0].toUpperCase()}
      </span>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
    >
      {icon}
    </svg>
  );
}
